import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const codCheckoutFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.codCheckout, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
